<template>
  <div v-loading="showLoading" class="relative">
    <slot v-if="direction == 'bottom'"></slot>
    <transition name="el-zoom-in-top">
      <div class="mb-[10] duration-300" v-show="tips_.msg" :style="{ width: alertWidth }" :class="alertClasses">
        <el-alert @close="handleClose" v-show="tips_.msg" :title="tips_.msg" :type="tips_.type" show-icon> </el-alert>
      </div>
    </transition>
    <slot v-if="direction != 'bottom'"></slot>
  </div>
</template>
<script>
export default {
  name: "dg-alert-box",
  props: {
    // 是否显示loading
    loading: {
      type: Boolean,
      default: true,
    },
    // 是否 tips
    tips: {
      type: Boolean,
      default: true,
    },
    urls: {
      type: Array,
      default: () => {
        return [];
      },
    },
    alertWidth: {
      type: String,
      default: "",
    },
  },
  computed: {
    alertClasses() {
      const baseClasses = ["mb-[10]"];

      if (this.direction === "right") {
        return [...baseClasses, "right-[0] w-[400]", "absolute"];
      } else if (this.direction === "left") {
        return [...baseClasses, "left-[0] w-[400]", "absolute"];
      } else {
        return baseClasses;
      }
    },
  },
  data() {
    return {
      showLoading: false,
      dgFormDialogOpen: false,
      direction: "",
      tips_: {
        msg: "",
        type: "error",
      },
    };
  },
  methods: {
    /**
     * @author 伟健 / 张
     * @name 清除提示
     */
    handleClose() {
      this.tips_.msg = "";
      this.tips_.type = "error";
    },
  },
  mounted() {},
  created() {
    let time = null;
    Mirror.watch("tips_dg_alert_box_close", () => {
      this.handleClose();
    });
    // 监听弹窗打开 dg-form-dialog 如： 修改发票，防止多个loding 显示
    Mirror.watch("dg_form_dialog_open", () => {
      this.dgFormDialogOpen = true;
    });
    // 监听弹窗关闭 dg-form-dialog
    Mirror.watch("dg_form_dialog_close", () => {
      this.dgFormDialogOpen = false;
    });

    Mirror.watch(["tips_dg_alert_box", "tips_dg_alert_box_open"], (key, msg, url = "") => {
      if (this.urls.length > 0 && !this.urls.includes(url)) return; // 监听指定的URL ，不传则全部
      if (this.dgFormDialogOpen || !this.tips) return;
      if (typeof msg == "string") {
        this.tips_.msg = msg;
        this.tips_.type = "error";
      } else if (msg) {
        if (msg.type == "success") {
          clearInterval(time);
          time = setTimeout(() => {
            this.tips_.msg = "";
          }, 3000);
        }

        this.tips_.msg = msg.msg;
        this.tips_.type = msg.type;
      }
    });

    let loading = [];
    Mirror.watch("loading_dg_alert_box_open", (key, url) => {
      if (this.urls.length > 0 && !this.urls.includes(url)) return; // 监听指定的URL ，不传则全部
      if (this.dgFormDialogOpen || !this.loading) return;
      this.showLoading = true;
      loading.push(1);
    });
    Mirror.watch("loading_dg_alert_box_close", () => {
      loading.pop();
      if (!loading.length) {
        this.showLoading = false;
      }
    });
  },
};
</script>
 <style>.mb-\[10\] {
    margin-bottom: 10px
}
.relative {
    position: relative
}
.duration-300 {
    transition-duration: 300ms
}</style>